import api from "../index";

// ** --------- HTML Template API --------- ** //

// Create a new HTML template
export const createHtmlTemplate = (values: any) => {
  return api.post("/html-template", values);
};

// Get all HTML templates
export const getHtmlTemplates = () => {
  return api.get("/html-templates");
};

// Get HTML templates paginated
export const getHtmlTemplatesPaginated = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/html-templates/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/html-templates/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get a specific HTML template by ID
export const getHtmlTemplateById = (id: string) => {
  return api.get(`/html-template/${id}`);
};

// Update an HTML template
export const updateHtmlTemplate = (id: string, values: any) => {
  return api.put(`/html-template/${id}`, values);
};

// Delete an HTML template
export const deleteHtmlTemplate = (id: string) => {
  return api.delete(`/html-template/${id}`);
};

// Duplicate an HTML template
export const duplicateHtmlTemplate = async (bid: any) => {
  return await api.post(`/html-template/${bid}/duplicate`);
};

// ** --------- Default Templates API --------- ** //

// Seed default templates into the database
export const seedDefaultTemplates = (force: boolean = false) => {
  return api.post("/html-templates/seed-defaults", { force });
};

// Check if default templates are seeded
export const checkDefaultTemplatesSeeded = () => {
  return api.get("/html-templates/check-seeded");
};

// Get all default templates
export const getDefaultTemplates = () => {
  return api.get("/html-templates/defaults");
};

// Get templates by category
export const getTemplatesByCategory = (category: string) => {
  return api.get(`/html-templates/category/${category}`);
};

// Get templates by purpose
export const getTemplatesByPurpose = (purpose: string) => {
  return api.get(`/html-templates/purpose/${purpose}`);
};
